
import { APPROVEALL_SUCCESS, APPROVEALL_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const approveAllReducer = (state = initialState, action) => {
    switch (action.type) {
        case APPROVEALL_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case APPROVEALL_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default approveAllReducer;
